/* ==========================================================================
   Pawlidays Co. — product page behaviour
   - Size chart popup        [data-pw-dialog-open]
   - Bundle & save tiers     [data-pw-bundle]
   - Add-on checkbox         [data-pw-addon]
   - Delivery timeline       [data-pw-timeline]
   - Mini review rotator     [data-pw-rotator]
   ========================================================================== */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Popups ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-pw-dialog-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-pw-dialog-open'));
      if (dlg && dlg.showModal) { dlg.showModal(); }
      return;
    }
    if (e.target.closest && e.target.closest('[data-pw-dialog-close]')) {
      var d = e.target.closest('dialog'); if (d) d.close(); return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('pw-dialog')) e.target.close();
  });

  /* ---------- Money ---------- */
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (err) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- Bundle & save ---------- */
  function initBundle(box) {
    if (box.__pw) return; box.__pw = true;
    var section = box.closest('section, .shopify-section') || document;
    section.classList && section.classList.add('pw-has-bundle');
    var qtyInput = section.querySelector('.product-form__quantity input[name="quantity"], input.quantity__input');
    var form = section.querySelector('form[id^="product-form"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var prices = {};
    try { prices = JSON.parse(box.querySelector('[data-pw-bundle-prices]').textContent); } catch (err) {}
    var currency = box.getAttribute('data-currency');
    var tiers = Array.prototype.slice.call(box.querySelectorAll('[data-pw-tier]'));

    function setQty(q) {
      if (!qtyInput) return;
      qtyInput.value = q;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    function select(tier) {
      tiers.forEach(function (t) { t.classList.toggle('is-active', t === tier); var r = t.querySelector('input'); if (r) r.checked = t === tier; });
      setQty(parseInt(tier.getAttribute('data-qty'), 10) || 1);
    }
    function reprice() {
      var vid = idInput && idInput.value;
      var p = prices[vid]; if (!p) return;
      tiers.forEach(function (t) {
        var q = parseInt(t.getAttribute('data-qty'), 10) || 1;
        var disc = parseFloat(t.getAttribute('data-discount')) || 0;
        var total = Math.round(p[0] * q * (100 - disc) / 100);
        var compare = p[1] * q;
        var tt = t.querySelector('[data-pw-tier-total]'); if (tt) tt.textContent = money(total, currency);
        var tc = t.querySelector('[data-pw-tier-compare]'); if (tc) tc.textContent = money(compare, currency);
        var ts = t.querySelector('[data-pw-tier-saved]'); if (ts) ts.textContent = money(Math.max(0, compare - total), currency);
      });
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); select(t); });
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(t); } });
      t.setAttribute('tabindex', '0');
    });
    var start = box.querySelector('[data-pw-tier].is-active') || tiers[0];
    if (start) select(start);
    if (form) form.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') reprice(); });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () { setTimeout(reprice, 0); });
    }
    if (idInput) new MutationObserver(reprice).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    reprice();
  }

  /* ---------- Add-on checkbox ---------- */
  function initAddon(label) {
    if (label.__pw) return; label.__pw = true;
    var variantId = label.getAttribute('data-pw-addon');
    var check = label.querySelector('input[type="checkbox"]');
    if (!variantId || !check) return;
    var pending = false;

    var section = label.closest('.shopify-section') || document;
    var mainForm = section.querySelector('form[id^="product-form"]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function addAddon() {
      if (!check.checked || pending) return;
      pending = true;
      var cart = document.querySelector('cart-drawer');
      // Only one protection plan per cart: skip if it's already there.
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var has = c && c.items && c.items.some(function (it) { return String(it.variant_id) === String(variantId); });
          if (has) return null;
          var body = { items: [{ id: Number(variantId), quantity: 1 }] };
          if (cart && cart.getSectionsToRender) {
            body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
            body.sections_url = window.location.pathname;
          }
          return fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
          }).then(function (r) { return r.json(); });
        })
        .then(function (state) {
          if (!state || state.status) return;
          if (cart && cart.renderContents && state.sections) { try { cart.renderContents(state); } catch (err) {} }
          else {
            // Notification / page cart: refresh the cart count bubble.
            fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
              document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) { el.textContent = c.item_count; });
            }).catch(function () {});
          }
        })
        .catch(function () {})
        .then(function () { setTimeout(function () { pending = false; }, 1200); });
    }

    function isThisProduct(evt) {
      if (!mainForm) return true;
      var idInput = mainForm.querySelector('input[name="id"]');
      return !evt.productVariantId || !idInput || String(evt.productVariantId) === String(idInput.value);
    }

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (evt) {
        if (evt && evt.source === 'product-form' && isThisProduct(evt)) setTimeout(addAddon, 150);
      });
    } else if (mainForm) {
      mainForm.addEventListener('submit', function () { setTimeout(addAddon, 900); }, true);
    }
  }

  /* ---------- Delivery timeline ---------- */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function fmt(d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); }
  function range(a, b) { var A = fmt(a), B = fmt(b); return A === B ? A : A + ' – ' + B; }
  function initTimeline(tl) {
    if (tl.__pw) return; tl.__pw = true;
    var n = function (k) { return parseInt(tl.getAttribute(k), 10) || 0; };
    var today = new Date();
    var rMin = n('data-ready-min'), rMax = Math.max(n('data-ready-max'), rMin);
    var sMin = n('data-ship-min'), sMax = Math.max(n('data-ship-max'), sMin);
    var set = function (k, v) { var el = tl.querySelector('[data-pw-tl="' + k + '"]'); if (el) el.textContent = v; };
    set('ordered', fmt(today));
    set('ready', range(addBusinessDays(today, rMin), addBusinessDays(today, rMax)));
    set('delivered', range(addBusinessDays(today, rMin + sMin), addBusinessDays(today, rMax + sMax)));
    if ('IntersectionObserver' in window && !reduceMotion) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { tl.classList.add('pw-in-view'); io.disconnect(); } }, { threshold: .4 });
      io.observe(tl);
    } else { tl.classList.add('pw-in-view'); }
  }

  /* ---------- Rotator ---------- */
  function initRotator(box) {
    if (box.__pw) return; box.__pw = true;
    var items = Array.prototype.slice.call(box.querySelectorAll('.pw-pdp-fr__item'));
    if (items.length < 2) return;
    var dotsWrap = box.querySelector('[data-pw-rotator-dots]');
    var i = 0, timer = null, ms = parseInt(box.getAttribute('data-interval'), 10) || 5000;
    var dots = items.map(function (_, k) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Review ' + (k + 1));
      b.addEventListener('click', function () { show(k); restart(); });
      if (dotsWrap) dotsWrap.appendChild(b); return b;
    });
    function show(k) {
      i = (k + items.length) % items.length;
      items.forEach(function (it, j) { it.classList.toggle('is-active', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function restart() { clearInterval(timer); if (!reduceMotion) timer = setInterval(function () { show(i + 1); }, ms); }
    box.addEventListener('mouseenter', function () { clearInterval(timer); });
    box.addEventListener('mouseleave', restart);
    show(0); restart();
  }

  /* ---------- Photo lightbox (pw-gallery) ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-pw-lightbox]');
    var step = e.target.closest && e.target.closest('[data-pw-lightbox-step]');
    if (trigger) {
      var group = trigger.closest('[data-pw-lightbox-group]');
      var dlg = group && document.getElementById('pw-lightbox-' + group.getAttribute('data-pw-lightbox-group'));
      if (!dlg || !dlg.showModal) return;
      var list = Array.prototype.slice.call(group.querySelectorAll('[data-pw-lightbox]'));
      dlg.__pwList = list;
      showLightbox(dlg, list.indexOf(trigger));
      dlg.showModal();
    } else if (step) {
      var d = step.closest('dialog');
      if (d && d.__pwList) showLightbox(d, d.__pwIndex + parseInt(step.getAttribute('data-pw-lightbox-step'), 10));
    }
  });
  document.addEventListener('keydown', function (e) {
    var d = document.querySelector('dialog.pw-lightbox[open]');
    if (!d || !d.__pwList) return;
    if (e.key === 'ArrowRight') showLightbox(d, d.__pwIndex + 1);
    if (e.key === 'ArrowLeft') showLightbox(d, d.__pwIndex - 1);
  });
  function showLightbox(dlg, i) {
    var list = dlg.__pwList; if (!list || !list.length) return;
    i = (i + list.length) % list.length; dlg.__pwIndex = i;
    var img = dlg.querySelector('[data-pw-lightbox-img]'), cap = dlg.querySelector('[data-pw-lightbox-cap]');
    img.style.opacity = 0;
    img.onload = function () { img.style.transition = 'opacity .3s'; img.style.opacity = 1; };
    img.src = list[i].getAttribute('data-pw-lightbox');
    img.alt = list[i].getAttribute('data-pw-caption') || '';
    cap.textContent = list[i].getAttribute('data-pw-caption') || '';
    dlg.querySelectorAll('[data-pw-lightbox-step]').forEach(function (b) { b.hidden = list.length < 2; });
  }

  /* ---------- Arrow buttons for swipe rows ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pw-scroll]');
    if (!btn) return;
    var track = document.getElementById(btn.getAttribute('data-pw-scroll-target'));
    if (!track) return;
    var card = track.firstElementChild;
    var stepPx = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * .8;
    var dir = parseInt(btn.getAttribute('data-pw-scroll'), 10);
    var max = track.scrollWidth - track.clientWidth - 2;
    if (dir > 0 && track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
    else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: max, behavior: 'smooth' });
    else track.scrollBy({ left: dir * stepPx, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ---------- Smooth accordions (pw-faq) ---------- */
  function initAccordion(det) {
    if (det.__pw) return; det.__pw = true;
    var summary = det.querySelector('summary');
    var body = summary && summary.nextElementSibling;
    if (!summary || !body || reduceMotion || !body.animate) return;
    var anim = null;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (anim) anim.cancel();
      if (det.open) {
        var h = body.offsetHeight;
        det.classList.add('pw-closing');
        anim = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: 'cubic-bezier(.2,.75,.2,1)' });
        anim.onfinish = function () { det.open = false; det.classList.remove('pw-closing'); anim = null; };
      } else {
        det.open = true;
        var target = body.offsetHeight;
        anim = body.animate([{ height: '0px', opacity: 0 }, { height: target + 'px', opacity: 1 }], { duration: 360, easing: 'cubic-bezier(.2,.75,.2,1)' });
        anim.onfinish = function () { anim = null; };
      }
    });
  }

  /* ---------- Frequently bought together ---------- */
  function initFbt(box) {
    if (box.__pw) return; box.__pw = true;
    var currency = box.getAttribute('data-currency');
    var items = Array.prototype.slice.call(box.querySelectorAll('[data-pw-fbt-item]'));
    var totalEl = box.querySelector('[data-pw-fbt-total]'), cmpEl = box.querySelector('[data-pw-fbt-compare]');
    var btn = box.querySelector('[data-pw-fbt-add]'), err = box.querySelector('[data-pw-fbt-error]');
    function chosen(item) {
      var sel = item.querySelector('[data-pw-fbt-variant]');
      if (!sel) return null;
      var opt = sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : sel;
      return { id: Number(sel.value), price: Number(opt.getAttribute('data-price')) || 0, compare: Number(opt.getAttribute('data-compare')) || 0 };
    }
    function update() {
      var total = 0, compare = 0, count = 0;
      items.forEach(function (item) {
        var on = item.querySelector('[data-pw-fbt-on]').checked;
        item.classList.toggle('is-on', on);
        var c = chosen(item); if (!c) return;
        var p = item.querySelector('[data-pw-fbt-price]'); if (p) p.textContent = money(c.price, currency);
        var w = item.querySelector('[data-pw-fbt-was]'); if (w) { w.hidden = !(c.compare > c.price); w.textContent = money(c.compare, currency); }
        if (on) { total += c.price; compare += Math.max(c.compare, c.price); count++; }
      });
      if (totalEl) totalEl.textContent = money(total, currency);
      if (cmpEl) { cmpEl.hidden = !(compare > total); cmpEl.textContent = money(compare, currency); }
      if (btn) btn.disabled = count === 0;
    }
    box.addEventListener('change', update);
    if (btn) btn.addEventListener('click', function () {
      var list = [];
      items.forEach(function (item) { if (item.querySelector('[data-pw-fbt-on]').checked) { var c = chosen(item); if (c) list.push({ id: c.id, quantity: 1 }); } });
      if (!list.length) return;
      btn.setAttribute('aria-busy', 'true'); if (err) err.hidden = true;
      var cart = document.querySelector('cart-drawer');
      var body = { items: list };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state.status) { if (err) { err.textContent = state.description || state.message || 'Something went wrong.'; err.hidden = false; } return; }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pw-fbt', cartData: state });
          if (cart && cart.renderContents && state.sections) { cart.classList.remove('is-empty'); cart.renderContents(state); }
          else window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
        })
        .catch(function () { if (err) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; } })
        .then(function () { btn.removeAttribute('aria-busy'); });
    });
    update();
  }

  /* ---------- Boot ---------- */
  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-pw-bundle]').forEach(initBundle);
    scope.querySelectorAll('[data-pw-addon]').forEach(initAddon);
    scope.querySelectorAll('[data-pw-timeline]').forEach(initTimeline);
    scope.querySelectorAll('[data-pw-rotator]').forEach(initRotator);
    scope.querySelectorAll('[data-pw-accordion]').forEach(initAccordion);
    scope.querySelectorAll('[data-pw-fbt]').forEach(initFbt);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { init(e.target.closest('.shopify-section') || document); });
})();
